import React, { Component, Fragment } from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { API_URL } from '../Actions/Config'
import Header from './Common/Header'
import Footer from './Common/Footer'
import Helmet from './Common/Helmet'
import { getAboutUs } from "../Actions/HelpAction"

const mapStateToProps = (state) => {
    return {
        helpRed: state.HelpReducer
    }
}

const mapDispatchToProps = dispatch => ({
    getAboutUs: () => dispatch(getAboutUs())
});


function getImageURL(data, type = "", url = "") {
    var image = ""

    switch (type) {
        case "banner":
            image = API_URL + "/" + data.banner_image
            break;
        case "one":
            image = API_URL + "/" + data.img_one
            break;
        case "two":
            image = API_URL + "/" + data.img_two
            break;
        case "three":
            image = API_URL + "/" + data.img_three
            break;
        case "url":
            image = API_URL + "/" + url
            break;

        default:
            break;
    }

    return image
}


class AboutUs extends Component {

    constructor(props) {
        super(props);

        this.state = {

        }

        this.props.getAboutUs()
    }

    componentDidMount() {
        window.scrollTo(0, 0)
    }

    render() {
        var about = this.props.helpRed.about
        return <Fragment>
            <Header Home={false} />

            <div id="main-container">
                <div class="page-banner" style={{ backgroundImage: `url(` + getImageURL(about, "banner") + `)` }}></div>

                <div className="page-title">
                    <div className="container title-cont">
                        <div className="row">
                            <div className="col-lg-12 title-inner">
                                <h1>{about.title}</h1>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="page-content about-us">
                    <div className="container">
                        <div className="row ">
                            <div className="abt-left col-lg-7">
                                <p> <div dangerouslySetInnerHTML={{ __html: about.content }} /> </p>
                                <div className="abt-logos">
                                    <img className="col-md-3" src={getImageURL(about, "one")} width="163" height="114" />
                                    <img className="col-md-3" src={getImageURL(about, "two")} width="163" height="75" />
                                    <img className="col-md-3" src={getImageURL(about, "three")} width="163" height="133" />
                                </div>
                            </div>

                            <div className="abt-right col-lg-5">
                                <div className="vm-block our-vision">
                                    <h3>Our Vision</h3>
                                    We aspire to be the premier Destination Management Company in Sri Lanka, distinguished by our commitment
                                    to innovation and excellence.
                                </div>

                                <div className="vm-block our-mission">
                                    <h3>Our Mission</h3>
                                    Our mission is to redefine the travel experience in Sri Lanka by providing unparalleled Destination
                                    Management services. We are dedicated to fostering innovation, delivering excellence, and creating
                                    unforgettable journeys that reflect the unique charm and beauty of our island nation. Through a
                                    commitment to sustainability and community engagement, we aim to set new standards in the travel
                                    industry, enriching the lives of our clients and contributing to the prosperity of local communities.
                                </div>

                            </div>

                            <div className="clear"></div>
                        </div>
                    </div>
                    <br />

                    <div className="core-echical-values">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-5 core-values">
                                    <h2>Core Values</h2>
                                    <div className="cv-item">
                                        <div className="cv-img"><img src={getImageURL(about, "url", 'assets/website/images/icon-accountability.png')} width="33" height="41" /></div>
                                        <div className="cv-title">Accountability</div>
                                        We will take responsibility for our area of influence as if this is our enterprise. We will commit to excellence.
                                    </div>
                                    <div className="cv-item">
                                        <div className="cv-img"><img src={getImageURL(about, "url", 'assets/website/images/icon-integrity.png')} width="34" height="34" /></div>
                                        <div className="cv-title">Integrity </div>
                                        We will walk the talk. We will be committed to a consistent, honest and reliable way of action.
                                    </div>
                                    <div className="cv-item">
                                        <div className="cv-img"><img src={getImageURL(about, "url", 'assets/website/images/')} width="53" height="33" /></div>
                                        <div className="cv-title">Respect </div>
                                        We appreciate other individuals with their own cultural identities. We embrace differences.
                                    </div>
                                    <div className="cv-item">
                                        <div className="cv-img"><img src={getImageURL(about, "url", 'assets/website/images/icon-tam-spirit.png')} width="49" height="42" /></div>
                                        <div className="cv-title">Team Spirit </div>
                                        We actively contribute to overcome challenges as a team.
                                    </div>
                                    <div className="cv-item">
                                        <div className="cv-img"><img src={getImageURL(about, "url", 'assets/website/images/icon-transparency.png')} width="36" height="35" /></div>
                                        <div className="cv-title">Transparency </div>
                                        We will provide full information required. We will communicate openly and sincerely. We appreciate feedback.
                                    </div>
                                </div>

                                <div className="col-lg-6 pull-right ethical-portfolio">
                                    <div className="ethical">
                                        <h2>Ethical Standards</h2>
                                        <p>We will conduct ourselves in an ethical manner and act as a good corporate citizen in all communities in which the Company operates.
                                        </p>
                                        <p>We care about the natural environment. In all our activities we wish to protect the environment from harmful influences, conserve natural resources and promote environmental awareness.</p>
                                    </div>

                                    <div className="portfolio">
                                        <h2>Product Portfolio</h2>
                                        <p>Find & Book top authentic experiences, tours and activities in Sri Lanka including Airport Transfers, Sightseeing, Nature & Wildlife, Culture & Heritage, Yoga & Meditation, Adventure, Ayurveda & Wellness, Wine & Dine, Village experiences, Honeymoon Tours, Beach Vacations, Sailing & Cruising, Ramayana Trails and many more off the beaten track tours.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <div className="our-team parallaxie">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="row">
                                        <div className='col-lg-7' />
                                        <div className="col-lg-5 pull-right">
                                            <div className="our-team-inner">
                                                <h3>Our Team</h3>
                                                <p>Our team consists with talented young professionals with very good experience in the industry who strives to go an extra mile to satisfy our guests. We are also equipped with one of the most experienced and professional team of English Speaking chauffeur guides who can add value to your visit.</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>


            <Footer hyperLink={false}/>

        </Fragment>
    }
}

export default compose(connect(mapStateToProps, mapDispatchToProps))(AboutUs);